import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import clock from "../../../assets/Icon/clockevent.png";
import flag from "../../../assets/Icon/flag.png";
import flag4 from "../../../assets/Icon/Interval-01.1.png";
import flag2 from "../../../assets/Icon/Maximum-Time-01.1.png";
import flag3 from "../../../assets/Icon/Minimum-Time-01.1.png";
import flag1 from "../../../assets/Icon/Registration-End-01.1.png";

import axios from "axios";
import { Markup } from "interweave";
import moment from "moment";
import {
  buildStyles,
  CircularProgressbarWithChildren,
} from "react-circular-progressbar";
import "../../../assets/CSS/SuperStarContent.css";
import { serverInfo } from "../../../App";
import { useContext } from "react";
import Countdown from "react-countdown";
import ContdownTimerRender from "../../../HelperComponent/ContdownTimerRender";

const LiveChatDetails = (props) => {
  const { imageCdnUrl } = useContext(serverInfo);
  const history = useHistory();

  const [event, setEvent] = useState("");
  const [eventTime, setEventTime] = useState('');

  useEffect(() => {
    let isMounted = true;

    const event_id = props.match.params.id;

    axios.get(`/api/admin/live-chat/details/${event_id}`).then((res) => {
      if (isMounted) {
        if (res.data.status === 200) {
          setEvent(res.data.event);
          setEventTime(res.data.event?.event_date);

          // if (res.data.event?.status > 1) {
          //   history.push(`/superstar-admin/live-chat/details/${event_id}`);
          // }
        }
      }
    });
  }, [props.match.params.slug, history]);


  const startTime = moment(eventTime).format("LL") + " " + event.start_time;



  return (
    <>
      <div className="AS">
        <div className="container-fluid">
          <div className="row mb-3">
            <div className="col-sm-12 col-md-12 col-lg-6 m-0 mb-3">
              <div className="card card-bg p-2">
                <img
                  src={imageCdnUrl + event.banner}
                  alt=""
                  className="img-fluid Banner-SME-b "
                />
              <Countdown
              date={startTime}
              renderer={ContdownTimerRender}
            />
          </div>
            </div>
            <div className="col-sm-12 col-md-12 col-lg-6 m-0 mb-3">
              <div className="registration-head  card-bg mb-1">
                <h5 className="text-warning fw-bold p-2">Registration </h5>
              </div>

              <div className="row registration-body  card-bg m-0 pt-3">
                <div className="col-md-6 m-0 ">
                  <div className="d-flex registration-btn p-2">
                    <div className="mx-3 mt-2">
                      <span className="text-light">
                        <img src={flag} alt="" className="PriceTage" />
                      </span>
                    </div>
                    <div className=" mx-1">
                      <span className="text-light">Registration Start:</span>
                      <br></br>
                      <span className=" text-warning fw-bold">
                        {moment(event.registration_start_date).format("LL")}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="col-md-6 m-0 ">
                  <div className="d-flex registration-btn p-2">
                    <div className="mx-3 mt-2">
                      <span className="text-light">
                        <img src={flag1} alt="" className="PriceTage" />
                      </span>
                    </div>
                    <div className=" mx-1">
                      <span className="text-light">Registration End:</span>
                      <br></br>
                      <span className=" text-warning fw-bold">
                        {moment(event.registration_end_date).format("LL")}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="col-md-6 m-0 ">
                  <div className="d-flex registration-btn p-2">
                    <div className="mx-3 mt-2">
                      <span className="text-light">
                        <img src={flag2} alt="" className="PriceTage" />
                      </span>
                    </div>
                    <div className=" mx-1">
                      <span className="text-light">Maximum Time:</span>
                      <br></br>
                      <span className=" text-warning fw-bold">
                        {event.max_time} Minute(s)
                      </span>
                    </div>
                  </div>
                </div>

                <div className="col-md-6 m-0 ">
                  <div className="d-flex registration-btn p-2">
                    <div className="mx-3 mt-2">
                      <span className="text-light">
                        <img src={flag3} alt="" className="PriceTage" />
                      </span>
                    </div>
                    <div className=" mx-1">
                      <span className="text-light">Minimum Time:</span>
                      <br></br>
                      <span className=" text-warning fw-bold">
                        {event.min_time} Minute(s)
                      </span>
                    </div>
                  </div>
                </div>

                <div className="col-md-6 m-0 ">
                  <div className="d-flex registration-btn p-2">
                    <div className="mx-3 mt-2">
                      <span className="text-light">
                        <img src={flag4} alt="" className="PriceTage" />
                      </span>
                    </div>
                    <div className=" mx-1">
                      <span className="text-light">Interval:</span>
                      <br></br>
                      <span className=" text-warning fw-bold">
                        {event.interval} Minute(s)
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-12 mb-3">
            <div className="card card-bg shadow">
              <div className="card-body">
                <h5 className="text-light ">{event.title}</h5>

                <h5 className="text-warning">Description</h5>
                <div className="under-line"></div>
                <p className="text-light mt-2">
                  <Markup content={event.description} />
                </p>

                <h5 className="text-warning">Instruction</h5>
                <div className="under-line"></div>
                <p className="text-light mt-2">
                  <Markup content={event.instruction} />
                </p>

                <div className="col-md-3 card card-bg-event head-line my-2 mt-4 row justify-content-between mx-0">
                  <h5 className="text-warning pt-2 ">Fees : ${event.fee}</h5>
                  <p className="text-light fw-bold pt-2">
                    {moment(event.date).format("LL")}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="card card-bg my-4">
            <div className="row">
              <div className="col-md-4 d-flex justify-content-center align-items-center">
                <img src={clock} className="img-fluid p-3" alt="" />
              </div>
              <div className="col-md-4  align-items-center p-3">
                <h2 className="text-warning">Event Details submitted</h2>
                <p className="text-light">
                  &nbsp;
                  {event.star_approval === 1 && Number(event.status) === 0 ? (
                    <span className="fw-bold">Waiting for Manager Admin</span>
                  ) : event.star_approval === 0 &&
                    Number(event.status) === 0 ? (
                    <span className="fw-bold">Waiting for SuperStar</span>
                  ) : Number(event.status) === 1 ? (
                    "Approved By Superstar and Manager Admin"
                  ) : null}
                  &nbsp;
                </p>

                {Number(event.status) < 1 ? (
                  <p>
                    <div className="col-md-6">
                      <Link
                        to={`/superstar-admin/live-chat/edit/${event.id}`}
                      >
                        {" "}
                        <button className="btn btnEdit w-100 fw-bold">
                          Edit
                        </button>
                      </Link>
                    </div>
                  </p>
                ) : (
                  ""
                )}
              </div>

              <div
                className="col-md-4"
                style={{ borderLeft: "1px dashed yellow" }}
              >
                <h5 className="text-light text-center my-3">Status</h5>
                <div className="d-flex justify-content-center align-items-center ">
                  <div style={{ width: 150, height: 150 }}>
                    {Number(event.status) === 1 ? (
                      <CircularProgressbarWithChildren
                        value={50}
                        styles={buildStyles({ pathColor: `gold` })}
                      >
                        {/* <img style={{ width: 40, marginTop: -4 }} className='my-2' src={star} alt="doge" /> */}
                        <div style={{ fontSize: 12, marginTop: -5 }}>
                          <strong className="text-light">50% complete</strong>
                        </div>
                      </CircularProgressbarWithChildren>
                    ) : (
                      <CircularProgressbarWithChildren
                        value={0}
                        styles={buildStyles({ pathColor: `gold` })}
                      >
                        {/* <img style={{ width: 40, marginTop: -4 }} className='my-2' src={star} alt="doge" /> */}
                        <div style={{ fontSize: 12, marginTop: -5 }}>
                          <strong className="text-light">0% complete</strong>
                        </div>
                      </CircularProgressbarWithChildren>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LiveChatDetails;
